"use strict";

exports.__esModule = true;
exports.RoleListItem = RoleListItem;
var _react = _interopRequireDefault(require("react"));
var _ListView = require("../../Core/ListView");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Displays a role in a list.
 */
function RoleListItem(_ref) {
  var value = _ref.value;
  return /*#__PURE__*/_react["default"].createElement(_ListView.ListItemView, null, /*#__PURE__*/_react["default"].createElement("h4", null, value.name));
}